// Ícone SVG inline da bandeira JCB (sem requisição HTTP)
import * as React from 'react';

export function JcbIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="JCB" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <rect x="8" y="8" width="10" height="16" rx="2" fill="#0E4C96" />
      <rect x="19" y="8" width="10" height="16" rx="2" fill="#E11932" />
      <rect x="30" y="8" width="10" height="16" rx="2" fill="#0E8C3A" />
      <text
        x="24"
        y="20"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="7"
        fill="#fff"
      >
        JCB
      </text>
    </svg>
  );
}
